import { inject, Injectable, LOCALE_ID, provideAppInitializer } from "@angular/core";

@Injectable({ providedIn: "root" })
export class I18n {
  /** Lingue attive */
  activeLangs = [
    "en",
    "it",
    "fr",
    "de",
    "es"
  ];

  /*+ Lingua di default */
  locale = "en";

  setLocale() {
    const userLocale = localStorage.getItem("locale");

    /** Se l'utente ha già una lingua selezionata, controlla se è tra le lingue attive, e quindi la usa. */
    if (userLocale && this.activeLangs.includes(userLocale)) {
      this.locale = userLocale;
    } else {
      /** Se non ha già una lingua settata, controlla se la lingua del browser è tra quelle attive, e quindi la usa. Altrimenti resta quella di default impostata sopra. */
      const browserLang = navigator.language.split("-")[0];
      if (browserLang && this.activeLangs.includes(browserLang)) {
        this.locale = browserLang;
      }
    }
  }
}

// Load locale data at app start-up
function setLocale() {
  return provideAppInitializer(() => {
    const initializerFn = ((i18n: I18n) => () => {
      i18n.setLocale();
    })(inject(I18n));
    initializerFn();
  });
}

// Set the runtime locale for the app
function setLocaleId() {
  return {
    provide: LOCALE_ID,
    useFactory: (i18n: I18n) => i18n.locale,
    deps: [I18n]
  };
}

/** Per aggiungere una lingua:
 * - Creare il file json della lingua in assets/i18n
 * - In i18n.modules.ts nella funzione setLocale aggiornare la direttiva webpackInclude: /(it|en|de)\.js$/ aggiungendo la lingua
 * - Aggiungerla all'array activeLangs
 */
export const i18nModule = {
  setLocale: setLocale,
  setLocaleId: setLocaleId
};
